var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1031 -3254)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(1031 3254)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1024.525 3248.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.475,8.021a9.272,9.272,0,0,0-9.3,9.222c0,2.484,1.53,4.524,2.879,6.325l.042.054c.189.254.377.5.558.753a4.416,4.416,0,0,1,.727,1.658,3.257,3.257,0,0,0,3.169,2.592H23.4a3.256,3.256,0,0,0,3.169-2.593,4.4,4.4,0,0,1,.727-1.656c.168-.231.341-.463.543-.733l.1-.129c1.33-1.774,2.838-3.785,2.838-6.269A9.272,9.272,0,0,0,21.475,8.021Zm7.031,9.222c0,1.744-1.217,3.364-2.395,4.932l-.039.053c-.212.281-.42.56-.621.838a6.718,6.718,0,0,0-1.1,2.48,1.007,1.007,0,0,1-.953.829H19.551a1.007,1.007,0,0,1-.953-.829,6.669,6.669,0,0,0-1.1-2.481c-.212-.294-.434-.591-.66-.891-1.177-1.568-2.393-3.19-2.393-4.931a7.031,7.031,0,0,1,14.062,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.5,35.538H20.648a1.144,1.144,0,0,0,0,2.277H25.5a1.144,1.144,0,0,0,0-2.277Z",
    transform: "translate(-1.602 -5.794)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.5a7613cb95256ec7412447c1aa0f9697.svg";
export { ForwardRef as ReactComponent };